import { useCallback } from 'react';
import { message } from 'ui';
import { copyToClipboard } from 'features/copy-to-clipboard';
import { useGetInvitationTokenMutation } from '../../../queries';
import { useGenerateInvitationLink } from './useGenerateInvitationLink';

export const useCopyInvitationLink = () => {
  const { isPending: isCopyingInvitationLink, mutateAsync: getToken } = useGetInvitationTokenMutation();
  const generateInvitationLink = useGenerateInvitationLink();

  const copyInvitationLink = useCallback(
    async ({ communityId }: { communityId: string }) => {
      await copyToClipboard(async () => {
        const { token } = await getToken({ communityId });
        return generateInvitationLink({ communityId, token });
      });

      message.success('Invitation link successfully copied to clipboard');
    },
    [generateInvitationLink, getToken],
  );

  return { copyInvitationLink, isCopyingInvitationLink };
};
